// Location-specific data for Studio Ballet Izora multi-location setup

export const locations = {
  surabaya: {
    id: 'surabaya',
    slug: 'surabaya',
    city: 'Surabaya',
    country: 'Indonesia',
    countryCode: 'ID',
    timezone: 'Asia/Jakarta',
    currency: 'IDR',
    languages: ['id', 'en'],
    defaultLanguage: 'id',
    
    // SEO Data
    seo: {
      titleEn: "Studio Ballet Izora Surabaya | Children's Ballet School in East Java",
      titleId: "Studio Ballet Izora Surabaya | Sekolah Balet Anak di Jawa Timur",
      descriptionEn: "Premier ballet training for children aged 2-10 years in Surabaya, Indonesia. Expert instruction by certified teacher Ditamaya. Enroll your child in East Java's finest ballet academy.",
      descriptionId: "Pelatihan balet unggulan untuk anak usia 2-10 tahun di Surabaya, Indonesia. Instruksi ahli oleh guru bersertifikat Ditamaya. Daftarkan anak Anda di akademi balet terbaik Jawa Timur.",
      keywords: "ballet school Surabaya, kids ballet East Java, children dance class Surabaya, balet anak Surabaya, sekolah balet Jawa Timur, Studio Ballet Izora, Ditamaya ballet instructor"
    },
    
    // School Info
    schoolInfo: {
      name: "Studio Ballet Izora",
      location: "Surabaya, East Java, Indonesia",
      fullAddress: "Surabaya, East Java, Indonesia",
      taglineEn: "Classical Ballet Excellence in East Java",
      taglineId: "Keunggulan Balet Klasik di Jawa Timur",
      descriptionEn: "Studio Ballet Izora in Surabaya offers professional classical ballet training for young dancers aged 2-10 years. Our established academy in East Java has nurtured over 100 aspiring ballerinas under the expert guidance of certified instructor Ditamaya.",
      descriptionId: "Studio Ballet Izora di Surabaya menawarkan pelatihan balet klasik profesional untuk penari muda usia 2-10 tahun. Akademi kami yang mapan di Jawa Timur telah membina lebih dari 100 calon balerina di bawah bimbingan ahli instruktur bersertifikat Ditamaya.",
      ageRange: "2-10",
      studentsCount: "100+",
      yearsExperience: "5+",
      instagram: "https://www.instagram.com/studioballetizora",
      whatsapp: "+6281234567890",
      email: "info@balletizora.com",
      logoUrl: "/images/logo.jpg"
    },
    
    // Instructor
    instructor: {
      name: "Ditamaya",
      titleEn: "Founder & Lead Ballet Instructor",
      titleId: "Pendiri & Instruktur Balet Utama",
      bioEn: "Ditamaya established Studio Ballet Izora in Surabaya with a vision to bring world-class ballet education to East Java. With extensive training in classical ballet techniques and years of teaching experience, she has successfully nurtured over 100 young dancers, helping them discover the joy and discipline of ballet.",
      bioId: "Ditamaya mendirikan Studio Ballet Izora di Surabaya dengan visi untuk membawa pendidikan balet kelas dunia ke Jawa Timur. Dengan pelatihan ekstensif dalam teknik balet klasik dan pengalaman mengajar bertahun-tahun, beliau telah berhasil membina lebih dari 100 penari muda, membantu mereka menemukan kegembiraan dan disiplin balet.",
      image: "/images/instructor.png"
    },
    
    // Classes
    classes: [
      {
        id: 1,
        titleEn: "Pre-School Ballet",
        titleId: "Balet Pra-Sekolah",
        ageRange: "2-4",
        descriptionEn: "A magical introduction to ballet for our tiniest dancers in Surabaya. Through playful exercises and enchanting music, children develop coordination, rhythm, and a love for movement in a nurturing environment.",
        descriptionId: "Pengenalan ajaib ke dunia balet untuk penari terkecil kami di Surabaya. Melalui latihan bermain dan musik yang mempesona, anak-anak mengembangkan koordinasi, ritme, dan kecintaan terhadap gerakan dalam lingkungan yang penuh perhatian.",
        image: "/images/preschool.jpeg"
      },
      {
        id: 2,
        titleEn: "Pre-Primary & Primary",
        titleId: "Pra-Dasar & Dasar",
        ageRange: "5-7",
        descriptionEn: "Building strong ballet foundations for young learners in East Java. Students master fundamental positions, develop proper posture, and begin learning classical choreography while building confidence and grace.",
        descriptionId: "Membangun fondasi balet yang kuat untuk pelajar muda di Jawa Timur. Siswa menguasai posisi dasar, mengembangkan postur yang tepat, dan mulai mempelajari koreografi klasik sambil membangun kepercayaan diri dan keanggunan.",
        image: "/images/preprimary.jpeg"
      },
      {
        id: 3,
        titleEn: "Grade 1 - 2",
        titleId: "Kelas 1 - 2",
        ageRange: "8-10",
        descriptionEn: "Advanced training for dedicated young dancers preparing for formal examinations. Focus on refined technique, artistic expression, and performance preparation following international ballet standards.",
        descriptionId: "Pelatihan lanjutan untuk penari muda yang berdedikasi mempersiapkan ujian formal. Fokus pada teknik yang disempurnakan, ekspresi artistik, dan persiapan pertunjukan mengikuti standar balet internasional.",
        image: "/images/grade1.jpeg"
      }
    ],
    
    // Testimonials
    testimonials: [
      {
        id: 1,
        nameEn: "Mrs. Indira, Parent",
        nameId: "Ibu Indira, Orang Tua",
        textEn: "My daughter has blossomed since joining Studio Ballet Izora in Surabaya. Ditamaya creates such a warm, encouraging atmosphere. We've seen remarkable improvement in her confidence and posture.",
        textId: "Anak saya berkembang pesat sejak bergabung dengan Studio Ballet Izora di Surabaya. Ditamaya menciptakan suasana yang hangat dan mendukung. Kami melihat peningkatan luar biasa dalam kepercayaan diri dan posturnya."
      },
      {
        id: 2,
        nameEn: "Mr. Budi, Father",
        nameId: "Bapak Budi, Ayah",
        textEn: "The best children's ballet school in East Java! Professional curriculum and genuine care for each student's development. Our family is grateful we found this studio.",
        textId: "Sekolah balet anak terbaik di Jawa Timur! Kurikulum profesional dan kepedulian tulus terhadap perkembangan setiap siswa. Keluarga kami bersyukur menemukan studio ini."
      },
      {
        id: 3,
        nameEn: "Mrs. Sari, Mother",
        nameId: "Ibu Sari, Ibu",
        textEn: "After two years at Studio Ballet Izora, my daughter performed beautifully at the graduation ceremony at Pala Ballroom. The transformation has been incredible!",
        textId: "Setelah dua tahun di Studio Ballet Izora, anak saya tampil memukau di upacara kelulusan di Pala Ballroom. Transformasinya luar biasa!"
      }
    ],
    
    // Images
    images: {
      hero: "/images/hero.png",
      about: "/images/about.png",
      instructor: "/images/instructor.png"
    },
    
    // Gallery
    hasGallery: true,
    galleryTitle: {
      en: "Graduation 2026 - Pala Ballroom Suite Hotel Surabaya",
      id: "Kelulusan 2026 - Pala Ballroom Suite Hotel Surabaya"
    }
  },
  
  'kuala-lumpur': {
    id: 'kuala-lumpur',
    slug: 'kuala-lumpur',
    city: 'Kuala Lumpur',
    country: 'Malaysia',
    countryCode: 'MY',
    timezone: 'Asia/Kuala_Lumpur',
    currency: 'MYR',
    languages: ['en', 'ms'],
    defaultLanguage: 'en',
    
    // SEO Data
    seo: {
      titleEn: "Studio Ballet Izora Kuala Lumpur | Premier Children's Ballet Academy Malaysia",
      titleId: "Studio Ballet Izora Kuala Lumpur | Akademi Balet Anak Premier Malaysia",
      descriptionEn: "Discover classical ballet excellence for children aged 3-12 in Kuala Lumpur. International standard training with experienced instructors. Join Malaysia's growing ballet community.",
      descriptionId: "Temukan keunggulan balet klasik untuk anak usia 3-12 tahun di Kuala Lumpur. Pelatihan standar internasional dengan instruktur berpengalaman. Bergabunglah dengan komunitas balet Malaysia yang berkembang.",
      keywords: "ballet school Kuala Lumpur, kids ballet Malaysia, children dance class KL, ballet academy Malaysia, Studio Ballet Izora KL, ballet lessons Kuala Lumpur"
    },
    
    // School Info
    schoolInfo: {
      name: "Studio Ballet Izora",
      location: "Kuala Lumpur, Malaysia",
      fullAddress: "Kuala Lumpur, Malaysia",
      taglineEn: "International Ballet Excellence in Malaysia",
      taglineId: "Keunggulan Balet Internasional di Malaysia",
      descriptionEn: "Studio Ballet Izora brings its renowned ballet education program to Kuala Lumpur, offering world-class training for young dancers aged 3-12. Our Malaysian studio combines international teaching standards with a nurturing environment where children thrive.",
      descriptionId: "Studio Ballet Izora membawa program pendidikan balet terkenalnya ke Kuala Lumpur, menawarkan pelatihan kelas dunia untuk penari muda usia 3-12 tahun. Studio kami di Malaysia menggabungkan standar pengajaran internasional dengan lingkungan yang mendukung di mana anak-anak berkembang.",
      ageRange: "3-12",
      studentsCount: "50+",
      yearsExperience: "2+",
      instagram: "https://www.instagram.com/studioballetizora",
      whatsapp: "+60123456789",
      email: "kl@balletizora.com",
      logoUrl: "/images/logo.jpg"
    },
    
    // Instructor
    instructor: {
      name: "Ditamaya",
      titleEn: "Founder & Lead Ballet Instructor",
      titleId: "Pendiri & Instruktur Balet Utama",
      bioEn: "Ditamaya brings her passion for classical ballet to Kuala Lumpur, expanding Studio Ballet Izora's mission to nurture young dancers across Southeast Asia. With extensive training in classical ballet techniques and years of teaching experience, she has established international standards at our Malaysian studio.",
      bioId: "Ditamaya membawa kecintaannya pada balet klasik ke Kuala Lumpur, memperluas misi Studio Ballet Izora untuk membina penari muda di seluruh Asia Tenggara. Dengan pelatihan ekstensif dalam teknik balet klasik dan pengalaman mengajar bertahun-tahun, beliau telah menetapkan standar internasional di studio Malaysia kami.",
      image: "/images/instructor.png"
    },
    
    // Classes
    classes: [
      {
        id: 1,
        titleEn: "Little Stars",
        titleId: "Bintang Kecil",
        ageRange: "3-5",
        descriptionEn: "An enchanting first step into ballet for Kuala Lumpur's youngest dancers. Through imaginative play, gentle stretching, and classical music, children discover the joy of movement while developing motor skills and creativity.",
        descriptionId: "Langkah pertama yang mempesona ke dunia balet untuk penari termuda Kuala Lumpur. Melalui permainan imajinatif, peregangan lembut, dan musik klasik, anak-anak menemukan kegembiraan bergerak sambil mengembangkan keterampilan motorik dan kreativitas.",
        image: "/images/preschool.jpeg"
      },
      {
        id: 2,
        titleEn: "Rising Dancers",
        titleId: "Penari Berkembang",
        ageRange: "6-9",
        descriptionEn: "Foundational ballet training for children ready to embrace classical technique. Students in Kuala Lumpur learn proper alignment, basic positions, and begin their journey toward graceful movement and artistic expression.",
        descriptionId: "Pelatihan balet dasar untuk anak-anak yang siap merangkul teknik klasik. Siswa di Kuala Lumpur mempelajari keselarasan yang tepat, posisi dasar, dan memulai perjalanan mereka menuju gerakan anggun dan ekspresi artistik.",
        image: "/images/preprimary.jpeg"
      },
      {
        id: 3,
        titleEn: "Junior Ballet",
        titleId: "Balet Junior",
        ageRange: "10-12",
        descriptionEn: "Advanced preparation for aspiring dancers in Malaysia. This program focuses on technique refinement, choreographic complexity, and performance confidence, preparing students for international examinations and competitions.",
        descriptionId: "Persiapan lanjutan untuk penari yang bercita-cita tinggi di Malaysia. Program ini fokus pada penyempurnaan teknik, kompleksitas koreografi, dan kepercayaan diri dalam pertunjukan, mempersiapkan siswa untuk ujian dan kompetisi internasional.",
        image: "/images/grade1.jpeg"
      }
    ],
    
    // Testimonials
    testimonials: [
      {
        id: 1,
        nameEn: "Mrs. Tan, Parent",
        nameId: "Mrs. Tan, Orang Tua",
        textEn: "Finding Studio Ballet Izora in KL was a blessing. The international teaching approach combined with personal attention has helped my daughter develop both skill and confidence remarkably.",
        textId: "Menemukan Studio Ballet Izora di KL adalah berkah. Pendekatan pengajaran internasional yang dikombinasikan dengan perhatian personal telah membantu putri saya mengembangkan keterampilan dan kepercayaan diri secara luar biasa."
      },
      {
        id: 2,
        nameEn: "Mr. Ahmad, Father",
        nameId: "Mr. Ahmad, Ayah",
        textEn: "The quality of instruction at Studio Ballet Izora Kuala Lumpur matches the best academies in the region. My daughters love their classes and we've seen tremendous growth in their abilities.",
        textId: "Kualitas instruksi di Studio Ballet Izora Kuala Lumpur setara dengan akademi terbaik di kawasan ini. Putri-putri saya menyukai kelas mereka dan kami telah melihat pertumbuhan luar biasa dalam kemampuan mereka."
      },
      {
        id: 3,
        nameEn: "Mrs. Lee, Mother",
        nameId: "Mrs. Lee, Ibu",
        textEn: "Professional, caring, and truly dedicated to each child's development. Studio Ballet Izora has become an important part of our family's weekly routine in Kuala Lumpur.",
        textId: "Profesional, penuh perhatian, dan benar-benar berdedikasi pada perkembangan setiap anak. Studio Ballet Izora telah menjadi bagian penting dari rutinitas mingguan keluarga kami di Kuala Lumpur."
      }
    ],
    
    // Images
    images: {
      hero: "/images/hero.png",
      about: "/images/about.png",
      instructor: "/images/instructor.png"
    },
    
    // Gallery
    hasGallery: true,
    galleryTitle: {
      en: "Studio Ballet Izora Gallery",
      id: "Galeri Studio Ballet Izora"
    }
  },
  
  tunis: {
    id: 'tunis',
    slug: 'tunis',
    city: 'Tunis',
    country: 'Tunisie',
    countryCode: 'TN',
    timezone: 'Africa/Tunis',
    currency: 'TND',
    languages: ['fr', 'en'],
    defaultLanguage: 'fr',
    
    // SEO Data
    seo: {
      titleEn: "Studio Ballet Izora Tunis | Classical Ballet Academy for Children in Tunisia",
      titleFr: "Studio Ballet Izora Tunis | Académie de Ballet Classique pour Enfants en Tunisie",
      descriptionEn: "Experience world-class ballet education in Tunis, Tunisia. Professional training for children aged 4-14. Join North Africa's premier children's ballet studio with international standards.",
      descriptionFr: "Découvrez une éducation de ballet de classe mondiale à Tunis, Tunisie. Formation professionnelle pour enfants de 4 à 14 ans. Rejoignez le premier studio de ballet pour enfants d'Afrique du Nord aux normes internationales.",
      keywords: "école de ballet Tunis, ballet enfants Tunisie, cours de danse enfants Tunis, académie ballet Tunisie, Studio Ballet Izora Tunis, cours ballet Tunisie, ballet Afrique du Nord, ballet school Tunis, kids ballet Tunisia"
    },
    
    // School Info
    schoolInfo: {
      name: "Studio Ballet Izora",
      location: "Tunis, Tunisie",
      fullAddress: "Tunis, Tunisie",
      taglineEn: "Classical Ballet Excellence in North Africa",
      taglineFr: "L'Excellence du Ballet Classique en Afrique du Nord",
      descriptionEn: "Studio Ballet Izora proudly extends its ballet education mission to Tunis, bringing classical dance excellence to North Africa. Our Tunisian studio offers professional training for children aged 4-14, blending international standards with the rich cultural heritage of Tunisia.",
      descriptionFr: "Studio Ballet Izora étend fièrement sa mission d'éducation au ballet à Tunis, apportant l'excellence de la danse classique en Afrique du Nord. Notre studio tunisien offre une formation professionnelle pour les enfants de 4 à 14 ans, alliant les normes internationales au riche patrimoine culturel de la Tunisie.",
      ageRange: "4-14",
      studentsCount: "30+",
      yearsExperience: "1+",
      instagram: "https://www.instagram.com/studioballetizora",
      whatsapp: "+21612345678",
      email: "tunis@balletizora.com",
      logoUrl: "/images/logo.jpg"
    },
    
    // Instructor
    instructor: {
      name: "Ditamaya",
      titleEn: "Founder & Lead Ballet Instructor",
      titleFr: "Fondatrice & Instructrice Principale de Ballet",
      bioEn: "Ditamaya extends Studio Ballet Izora's vision to North Africa, bringing world-class ballet education to Tunis. With her extensive background in classical ballet and dedication to nurturing young talent, she has established a premier dance academy that combines international standards with Tunisia's rich cultural heritage.",
      bioFr: "Ditamaya étend la vision de Studio Ballet Izora en Afrique du Nord, apportant une éducation de ballet de classe mondiale à Tunis. Avec sa vaste expérience en ballet classique et son dévouement à former les jeunes talents, elle a établi une académie de danse de premier plan qui combine les normes internationales avec le riche patrimoine culturel de la Tunisie.",
      image: "/images/instructor.png"
    },
    
    // Classes
    classes: [
      {
        id: 1,
        titleEn: "Petits Danseurs",
        titleFr: "Petits Danseurs",
        ageRange: "4-6",
        descriptionEn: "A gentle introduction to classical ballet for Tunisia's youngest dancers. Through storytelling, music, and movement games, children in Tunis develop coordination, musicality, and a love for the art of dance.",
        descriptionFr: "Une introduction douce au ballet classique pour les plus jeunes danseurs de Tunisie. À travers des histoires, de la musique et des jeux de mouvement, les enfants de Tunis développent la coordination, la musicalité et l'amour de l'art de la danse.",
        image: "/images/preschool.jpeg"
      },
      {
        id: 2,
        titleEn: "Ballet Foundation",
        titleFr: "Fondation Ballet",
        ageRange: "7-10",
        descriptionEn: "Building strong technical foundations for young dancers in Tunisia. Students learn classical positions, proper alignment, and begin exploring the rich vocabulary of ballet movement with discipline and joy.",
        descriptionFr: "Construire des bases techniques solides pour les jeunes danseurs en Tunisie. Les élèves apprennent les positions classiques, l'alignement correct, et commencent à explorer le riche vocabulaire du mouvement ballet avec discipline et joie.",
        image: "/images/preprimary.jpeg"
      },
      {
        id: 3,
        titleEn: "Ballet Avancé",
        titleFr: "Ballet Avancé",
        ageRange: "11-14",
        descriptionEn: "Intensive training for dedicated young dancers aspiring to excellence. This program in Tunis combines rigorous technique with artistic development, preparing students for performances and international ballet examinations.",
        descriptionFr: "Formation intensive pour les jeunes danseurs dévoués aspirant à l'excellence. Ce programme à Tunis combine une technique rigoureuse avec le développement artistique, préparant les élèves aux spectacles et aux examens de ballet internationaux.",
        image: "/images/grade1.jpeg"
      }
    ],
    
    // Testimonials
    testimonials: [
      {
        id: 1,
        nameEn: "Mrs. Fatma, Parent",
        nameFr: "Mme Fatma, Parent",
        textEn: "Finally, a world-class ballet school in Tunis! The instruction is exceptional and brings out the best in every child. My daughter's transformation has been remarkable.",
        textFr: "Enfin, une école de ballet de classe mondiale à Tunis ! L'enseignement est exceptionnel et fait ressortir le meilleur de chaque enfant. La transformation de ma fille a été remarquable."
      },
      {
        id: 2,
        nameEn: "Mr. Karim, Father",
        nameFr: "M. Karim, Père",
        textEn: "Studio Ballet Izora has brought international ballet standards to Tunisia. The professional approach and beautiful studio environment make it the perfect place for our children to learn.",
        textFr: "Studio Ballet Izora a apporté les normes internationales du ballet en Tunisie. L'approche professionnelle et le bel environnement du studio en font l'endroit parfait pour l'apprentissage de nos enfants."
      },
      {
        id: 3,
        nameEn: "Mrs. Salma, Mother",
        nameFr: "Mme Salma, Mère",
        textEn: "The discipline, grace, and confidence my daughter has gained at Studio Ballet Izora Tunis is invaluable. We are so grateful this academy opened in our city.",
        textFr: "La discipline, la grâce et la confiance que ma fille a acquises à Studio Ballet Izora Tunis sont inestimables. Nous sommes très reconnaissants que cette académie ait ouvert dans notre ville."
      }
    ],
    
    // Images
    images: {
      hero: "/images/hero.png",
      about: "/images/about.png",
      instructor: "/images/instructor.png"
    },
    
    // Gallery
    hasGallery: true,
    galleryTitle: {
      en: "Studio Ballet Izora Gallery",
      fr: "Galerie Studio Ballet Izora"
    }
  }
};

// Helper function to get location by slug
export const getLocationBySlug = (slug) => locations[slug] || null;

// Get all locations as array
export const getAllLocations = () => Object.values(locations);

// Get location slugs
export const getLocationSlugs = () => Object.keys(locations);

// Main brand info (for homepage)
export const brandInfo = {
  name: "Studio Ballet Izora",
  taglineEn: "Classical Ballet for Young Dancers",
  taglineId: "Balet Klasik untuk Penari Muda",
  descriptionEn: "Studio Ballet Izora is an international ballet academy dedicated to nurturing young dancers across Asia and Africa. With studios in Surabaya, Kuala Lumpur, and Tunis, we bring world-class classical ballet education to communities around the world.",
  descriptionId: "Studio Ballet Izora adalah akademi balet internasional yang berdedikasi untuk membina penari muda di seluruh Asia dan Afrika. Dengan studio di Surabaya, Kuala Lumpur, dan Tunis, kami membawa pendidikan balet klasik kelas dunia ke komunitas di seluruh dunia.",
  logoUrl: "/images/logo.jpg",
  instagram: "https://www.instagram.com/studioballetizora",
  email: "info@balletizora.com",
  
  // SEO for homepage
  seo: {
    titleEn: "Studio Ballet Izora | International Children's Ballet Academy",
    titleId: "Studio Ballet Izora | Akademi Balet Anak Internasional",
    descriptionEn: "International ballet academy with locations in Surabaya, Kuala Lumpur, and Tunis. Professional classical ballet training for children. Find a studio near you.",
    descriptionId: "Akademi balet internasional dengan lokasi di Surabaya, Kuala Lumpur, dan Tunis. Pelatihan balet klasik profesional untuk anak-anak. Temukan studio terdekat.",
    keywords: "Studio Ballet Izora, international ballet school, kids ballet Asia, children ballet Africa, ballet academy, classical ballet for children"
  }
};

// Benefits (shared across all locations)
export const benefits = [
  {
    titleEn: "Physical Development",
    titleId: "Perkembangan Fisik",
    descriptionEn: "Improves flexibility, coordination, and motor skills",
    descriptionId: "Meningkatkan fleksibilitas, koordinasi, dan keterampilan motorik",
    icon: "heart"
  },
  {
    titleEn: "Discipline & Focus",
    titleId: "Disiplin & Fokus",
    descriptionEn: "Builds concentration and self-discipline",
    descriptionId: "Membangun konsentrasi dan disiplin diri",
    icon: "star"
  },
  {
    titleEn: "Creative Expression",
    titleId: "Ekspresi Kreatif",
    descriptionEn: "Encourages artistic expression and imagination",
    descriptionId: "Mendorong ekspresi artistik dan imajinasi",
    icon: "sparkles"
  },
  {
    titleEn: "Confidence Building",
    titleId: "Membangun Kepercayaan Diri",
    descriptionEn: "Develops self-confidence through performance",
    descriptionId: "Mengembangkan kepercayaan diri melalui pertunjukan",
    icon: "trophy"
  },
  {
    titleEn: "Social Skills",
    titleId: "Keterampilan Sosial",
    descriptionEn: "Learn teamwork and make new friends",
    descriptionId: "Belajar kerja tim dan mendapat teman baru",
    icon: "users"
  },
  {
    titleEn: "Musical Awareness",
    titleId: "Kesadaran Musik",
    descriptionEn: "Develops rhythm and musical appreciation",
    descriptionId: "Mengembangkan ritme dan apresiasi musik",
    icon: "music"
  }
];
